module.exports = __webpack_public_path__ + "static/media/improvementAreasTitle.ecf671b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/improvementAreasTitle.png
// module id = 1297
// module chunks = 0